import { Company, DataRequestByPage, PaginationResponse } from "src/app/interfaces/base-entity";
import { GenericService } from "../../shared/services/generic.service";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CompanyService extends GenericService<Company> {

  private baseUrl = `${environment.host}/api/Company`;

  constructor(http: HttpClient) {
    super(http);
    this.setApiUrl(this.baseUrl);
  }

  createWithLogo(company: Company, logoFile: File): Observable<Company> {
    const formData = new FormData();
    formData.append('form', JSON.stringify(company));
    formData.append('file', logoFile);
    return this.http.post<Company>(`${this.baseUrl}/save`, formData);
  }

  override getAllByPage(rows: number, position: number, dataRequest: DataRequestByPage = { filters:[], sorts: []}): Observable<PaginationResponse<any>> {
        dataRequest.position = position;
        dataRequest.rows = rows;
        return this.http.post<PaginationResponse<any>>(`${this.baseUrl}/getAllByPage`,dataRequest);
    }   

  updateWithLogo(company: Company, logoFile: File): Observable<Company> {
    const formData = new FormData();
    formData.append('form', JSON.stringify(company));
    formData.append('file', logoFile);
    return this.http.put<Company>(`${this.baseUrl}/update`, formData);
  }
  

  

  
}